import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';

import { PrioritySubmissionEndpoint } from './prioritysubmissionendpoint.service';

import { DepartmentDto } from '../models/Department.model';
import { ExternalDocumentDto } from '../models/ExternalDocument.model';
import { FileUploadDto } from '../models/FileUpload.model';
import { BusinessRuleMessage } from '../models/BusinessRuleMessage.model';
import { PrioritySubmissionDto } from '../models/PrioritySubmission.model';
import { PrioritySubmissionItemTypeVldDto } from '../models/PrioritySubmissionItemTypeVld.model';
import { IndustryPanelVldDto } from '../models/IndustryPanelVld.model';
import { SubmissionStatusVldDto } from '../models/SubmissionStatusVld.model';
import { PrioritySubmissionThemesVldDto } from '../models/PrioritySubmissionThemesVld.model';
import { PrioritySubmissionThemeAssociationDto } from '../models/PrioritySubmissionThemeAssociations.model';
import { OrganizationDto } from '../models/Organization.model';
import { RtrApplicableVldDto } from '../models/RtrApplicableVld.model';
import { CrossCuttingThemesVldDto } from '../models/CrossCuttingThemesVld.model';

@Injectable()

export class PrioritySubmissionService {
  constructor(private router: Router, private prioritySubmissionEndpoint: PrioritySubmissionEndpoint) {
  }

  getOrganizations(userProfileID?: string) {

    return this.prioritySubmissionEndpoint.getOrganizations<OrganizationDto[]>(userProfileID);
  }

  getRtrApplicables(userProfileID?: string) {

    return this.prioritySubmissionEndpoint.getRtrApplicables<RtrApplicableVldDto[]>(userProfileID);

  }

  getDepartments(userProfileID?: string) {

    return this.prioritySubmissionEndpoint.getDepartments<DepartmentDto[]>(userProfileID);
  }

  getPrioritySubmissionItemTypes() {
    return this.prioritySubmissionEndpoint.getPrioritySubmissionItemTypes<PrioritySubmissionItemTypeVldDto[]>();
  }

  getCrossCuttingThemes() {
    return this.prioritySubmissionEndpoint.getCrossCuttingThemes<CrossCuttingThemesVldDto[]>();
  }


  getIndustryPanels() {
    return this.prioritySubmissionEndpoint.getIndustryPanels<IndustryPanelVldDto[]>();
  }

  getSubmissionStatus() {
    return this.prioritySubmissionEndpoint.getSubmissionStatus<SubmissionStatusVldDto[]>();
  }

  getPrioritySubmissionThemes() {
    return this.prioritySubmissionEndpoint.getPrioritySubmissionThemes<PrioritySubmissionThemesVldDto[]>();
  }

  getPrioritySubmission(prioritySubmissionID?: string, userProfileID?: string) {
    return this.prioritySubmissionEndpoint.getPrioritySubmission<PrioritySubmissionDto>(prioritySubmissionID, userProfileID);
  }

  getAllPrioritySubmissions(userProfileID?: string) {

    return this.prioritySubmissionEndpoint.getAllPrioritySubmissions<PrioritySubmissionDto[]>(userProfileID);
  }

  getPrioritySubmissionsByDepartment(departmentID?: string, annualPlanItemID?: string) {

    return this.prioritySubmissionEndpoint.getPrioritySubmissionsByDepartment<PrioritySubmissionDto[]>(departmentID, annualPlanItemID);
  }
  
  createPrioritySubmission() {

    return this.prioritySubmissionEndpoint.createPrioritySubmission<PrioritySubmissionDto>();
  }
  
  submitPrioritySubmission(prioritySubmission: PrioritySubmissionDto) {
    return this.prioritySubmissionEndpoint.submitPrioritySubmission<BusinessRuleMessage[]>(prioritySubmission);
  }

  async uploadExternalDocument(externalDocuments: ExternalDocumentDto[]) {
    let response = [];
    const formData = new FormData();
    for (let externalDocument of externalDocuments) {
      if (externalDocument.file != null) {
        formData.append(externalDocument.file.name, externalDocument.file);
      }
    }
    if (formData != null && externalDocuments.length > 0) {
      formData.append('folderkey', externalDocuments[0].prioritySubmissionID);
      await this.prioritySubmissionEndpoint.uploadExternalDocument(formData);
    }

    return response;
  }

  downloadFile(externalDocumentID: string, fileName: string) {
    return this.prioritySubmissionEndpoint.downloadFile(externalDocumentID, fileName);
  }
}
